/* eslint-disable */
import { useResizeObserver } from '@wojtekmaj/react-hooks';
import type { PDFDocumentProxy } from 'pdfjs-dist';
import type { FC } from 'react';
import { useCallback, useEffect, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { useAppSelector } from '@/Module/Store/Hook';
import { selectedLessonSectionSelector } from '@/Module/Lesson/Store/Selector/selectedLessonSectionSelector';
import LessonDetailLimitation from '@/Module/Lesson/Component/LessonDetail/LessonDetailLimitation';
import { useLoggedIn } from '@/Module/Auth/Hook';
import { useVideoDuration } from '@/Module/Core/Hook';
pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.js', import.meta.url).toString();
const options = {
  cMapUrl: '/cmaps/',
  standardFontDataUrl: '/standard_fonts/',
  withCredentials: false
};
const resizeObserverOptions = {};
const maxWidth = 1150;
const LessonDetailPDF: FC = () => {
  const lessonSection = useAppSelector(selectedLessonSectionSelector);
  const activeNumber = useAppSelector(state => state.lessonSection.activeTabNumber) === 2;
  const file = `https://static.hamrah.academy/handout/${lessonSection?.videoId}.pdf`;
  const [isFileExist, setFileExist] = useState<boolean | null>(null);
  const [numPages, setNumPages] = useState<number>();
  const [containerRef, setContainerRef] = useState<HTMLElement | null>(null);
  const [containerWidth, setContainerWidth] = useState<number>();
  const isLoggedIn = useLoggedIn();
  const {
    onLoginClick
  } = useVideoDuration();
  const hasAccessHandout = useAppSelector(state => state.subscription.selectedCourseAccess);
  const onResize = useCallback<ResizeObserverCallback>(entries => {
    const [entry] = entries;
    if (entry) {
      setContainerWidth(prevWidth => {
        const newWidth = entry.contentRect.width;
        return prevWidth !== newWidth ? newWidth : prevWidth;
      });
    }
  }, []);
  useResizeObserver(containerRef, resizeObserverOptions, onResize);
  const onDocumentLoadSuccess = ({
    numPages: nextNumPages
  }: PDFDocumentProxy): void => {
    setNumPages(nextNumPages);
  };
  useEffect(() => {
    if (!lessonSection?.videoId || !isLoggedIn || !hasAccessHandout) return () => {};
    const abortController = new AbortController();
    fetch(file, {
      signal: abortController.signal
    }).then(() => setFileExist(true)).catch(() => setFileExist(false));
    return () => {
      abortController.abort();
    };
  }, [lessonSection?.videoId]);
  return <>
      {(!isLoggedIn || !hasAccessHandout) && activeNumber ? <div>
          <LessonDetailLimitation isLoggedIn={isLoggedIn} hasAccessHandout={hasAccessHandout} onLoginClick={onLoginClick} type='handout' />
        </div> : <div>
          {isFileExist ? <div className="Example">
            <div className="Example__container">
              <div className="Example__container__document  viewerSidebar max-h-[420px] overflow-scroll  pl-4 pr-2 sm:max-h-[700px]" ref={setContainerRef}>
                <Document file={file} onLoadSuccess={onDocumentLoadSuccess} options={options}>
                  {Array.from(new Array(numPages), (_el, index) => <Page key={`page_${index + 1}`} pageNumber={index + 1} width={containerWidth ? Math.min(containerWidth, maxWidth) : maxWidth} />)}
                </Document>
              </div>
            </div>
          </div> : <div className="text-center w-full text-xl sm:text-2xl lg:text-4xl  py-10 font-bold text-blueFive border-2 mt-4 border-b-orangeFive">به
            زودی جزوه مرتبط بارگذاری می گردد.</div>}
        </div>}
    </>;
};
export default LessonDetailPDF;